/* モーダル */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface Props {
  show: boolean;
  title: string;
  body: string | JSX.Element;
  ClickCallBackYes: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  ClickCallBackNo: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const ModalTemplate: React.FC<Props> = ({
  show,
  title,
  body,
  ClickCallBackYes,
  ClickCallBackNo,
}) => {
  return (
    <Modal size="lg" centered show={show} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title className="dialog-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="dialog-body">{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="main-color" onClick={ClickCallBackYes}>
          はい
        </Button>
        <Button variant="main-color" onClick={ClickCallBackNo}>
          いいえ
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTemplate;
